import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DbsSpinnerComponent } from './dbs-spinner.component';
import { DbsSpinnerDirective } from './dbs-spinner.directive';

@NgModule({
    declarations: [DbsSpinnerComponent, DbsSpinnerDirective],
    exports: [
        DbsSpinnerComponent,
        DbsSpinnerDirective,
    ],
    imports: [
        CommonModule,
    ]
})
export class DbsSpinnerModule {
}
